import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ProfileService } from '../../modules/profile/profile.service';

export const loginGuard: CanActivateFn = () => {
  const authSrv = inject(ProfileService);
  const router = inject(Router);

  if (authSrv.isLoggedIn()) {
    void router.navigate(['/create']);
    return false;
  }

  return true;
};
